import { useEffect, type ReactNode } from 'react'
import { themes, DEFAULT_THEME, type ThemeName } from './index'
import { generateThemeCSS } from './generateThemeCSS'

const STYLE_TAG_ID = 'leadflow-theme-styles'

interface Props {
  theme?: ThemeName
  children: ReactNode
}

export function ThemeProvider({ theme = DEFAULT_THEME, children }: Props) {
  useEffect(() => {
    let tag = document.getElementById(STYLE_TAG_ID) as HTMLStyleElement | null
    if (!tag) {
      tag = document.createElement('style')
      tag.id = STYLE_TAG_ID
      document.head.appendChild(tag)
    }
    tag.textContent = generateThemeCSS(themes[theme])
  }, [theme])

  return <>{children}</>
}
